
import ComplianceBenchmarks from "@/components/ComplianceBenchmarks";
import SecurePageAccess from "@/components/SecurePageAccess";

export default function ComplianceBenchmarksPage() {
  return (
    <SecurePageAccess resourceName="compliance_benchmarks" requiredPermission="view">
      <div className="space-y-8 p-8">
        <ComplianceBenchmarks />
      </div>
    </SecurePageAccess>
  );
}
